import { doLinesIntersect } from './do-lines-intersect';

/**
 * Checks if any edge of the image (given by its four corner coordinates) intersects
 * with any edge of the photozone (also given by four corner coordinates, typically with margin).
 *
 * @param imageCoords - An array of four fabric.Points representing the image corners.
 * @param photoZoneMarginCoords - An array of four fabric.Points representing the photozone corners (with margin).
 * @returns True if any image edge intersects any photozone edge, false otherwise.
 */
export const checkIfImageIntersectsPhotozoneEdge = ({
  imageCoords,
  photoZoneMarginCoords,
}: {
  imageCoords: [fabric.Point, fabric.Point, fabric.Point, fabric.Point];
  photoZoneMarginCoords: [fabric.Point, fabric.Point, fabric.Point, fabric.Point];
}): boolean => {
  // Check if any image edge intersects with any photozone edge (with margin)
  for (let i = 0; i < 4; i++) {
    // eslint-disable-next-line security/detect-object-injection
    const imgA = imageCoords[i];
    const imgB = imageCoords[(i + 1) % 4];
    for (let j = 0; j < 4; j++) {
      // eslint-disable-next-line security/detect-object-injection
      const zoneA = photoZoneMarginCoords[j];
      const zoneB = photoZoneMarginCoords[(j + 1) % 4];
      if (doLinesIntersect(imgA, imgB, zoneA, zoneB)) {
        return true;
      }
    }
  }
  return false;
};
